const VoucherRequestType = {
  REQUEST: 1,
  RECEIVE: 2
}
export default VoucherRequestType
